<div class="flex items-center p-6">
  <form [formGroup]="form" (submit)="onSubmit()" class="w-full space-y-5">
    <div>
      <h2 class="text-xl font-semibold text-slate-800">
        Actualizar crédito WhatsApp
      </h2>
      <p class="text-sm text-slate-500">
        Edita los datos y guarda los cambios.
      </p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label
          for="creditos"
          class="block text-sm font-medium text-slate-700 mb-1"
          >Créditos</label
        >
        <input
          id="creditos"
          type="number"
          min="0"
          formControlName="creditos"
          class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="0"
        />
        @if (form.get("creditos")?.touched && form.get("creditos")?.invalid) {
          <p class="mt-1 text-xs text-red-600">
            Ingresa una cantidad de créditos válida.
          </p>
        }
      </div>

      <div>
        <label
          for="costo_por_mensaje"
          class="block text-sm font-medium text-slate-700 mb-1"
        >
          Costo por mensaje
        </label>
        <input
          id="costo_por_mensaje"
          type="number"
          min="0"
          step="0.0001"
          formControlName="costo_por_mensaje"
          class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          placeholder="0.0000"
        />
        @if (
          form.get("costo_por_mensaje")?.touched &&
          form.get("costo_por_mensaje")?.invalid
        ) {
          <p class="mt-1 text-xs text-red-600">
            Ingresa un costo por mensaje válido.
          </p>
        }
      </div>
    </div>

    <div>
      <label class="inline-flex items-center gap-2 cursor-pointer">
        <input
          type="checkbox"
          formControlName="activo"
          class="h-4 w-4 rounded border-slate-300 text-blue-600 focus:ring-blue-500"
        />
        <span class="text-sm font-medium text-slate-700">Activo</span>
      </label>
    </div>

    <div>
      <label for="motivo" class="block text-sm font-medium text-slate-700 mb-1"
        >Motivo</label
      >
      <textarea
        id="motivo"
        rows="4"
        formControlName="motivo"
        class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        placeholder="Describe el motivo de la actualización..."
      ></textarea>
      @if (form.get("motivo")?.touched && form.get("motivo")?.invalid) {
        <p class="mt-1 text-xs text-red-600">
          El motivo es obligatorio, min
          {{ form.get("motivo")?.value?.length }}/10 caracteres.
        </p>
      }
    </div>

    <div class="flex items-center justify-end gap-2 pt-2">
      <button
        type="button"
        (click)="onCancelar()"
        class="rounded-lg border border-slate-300 px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
      >
        Cancelar
      </button>
      <button
        type="submit"
        [disabled]="form.invalid"
        class="rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
      >
        Guardar cambios
      </button>
    </div>
  </form>
</div>
